'use client'
import React, { useState, useRef } from 'react'
import {
  Button,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  Input,
  Stack,
  Image,
  InputGroup,
  InputRightElement,
  Icon,
  useToast,
  Spinner,
} from '@chakra-ui/react'
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { RiEyeCloseLine } from "react-icons/ri";
import { useNavigate } from 'react-router-dom'
import axios from 'axios';
import Footer from '../Footer/Footer';

export default function Login() {
  const [show, setShow] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const handleClick = () => setShow(!show);
  const isButtonDisabled = email === '' || password === '';
  const toast = useToast();
  const toastIdRef = useRef();
  const navigate = useNavigate();

  const handleSubmit = async () => {
    try {
      toastIdRef.current = toast({
        icon: <Spinner />,       
        title: "Connexion en cours",
        description: "Veuillez patienter...",
        status: "loading",
        duration: null,
        isClosable: true,
      });
      const response = await axios.post('#', {

      }, {
        headers: {
          'Authorization': `Basic ${btoa(`${email}:${password}`)}`
        }
      });
      if (response.status === 200) {
        if (toastIdRef.current) {
          toast.update(toastIdRef.current, {
            title: "Connexion réussie",
            description: "Vous pouvez accéder au dashboard.",
            status: "success",
            duration: 5000,
            isClosable: true,
          })
        }
        navigate('/dashboard', { state: {loginData: { username: email, password }} });
      }
    } catch (error) {
      console.error('error', error);
      toast.update(toastIdRef.current, {
        title: "Erreur lors de la connexion",
        description: "Une erreur s'est produite lors de la connexion. Veuillez réessayer.",
        status: "error",
        duration: 9000,
        isClosable: true,
      })
      console.error('There was an error!', error);
    }
  };

  return (
    <>
        <Stack minH={'100vh'} direction={{ base: 'column', md: 'row' }}>
          <Flex flex={1}>
            <Image
              alt={'Login Image'}
              objectFit={'cover'}
              src={
                'https://images.unsplash.com/photo-1486312338219-ce68d2c6f44d?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1352&q=80'
              }
            />
          </Flex> 
          <Flex p={8} flex={1} align={'center'} justify={'center'}>
            <Stack spacing={6} w={'full'} maxW={'md'}>
              <Heading fontSize={'2xl'}>Connectez-vous</Heading>
              <Heading fontSize={'xl'}>Pour accéder au dashboard</Heading>
              <FormControl id="email">
                <FormLabel>Nom d'utilisateur</FormLabel>
                <Input 
                  type="email" 
                  color={'black'} 
                  bg={'white'} 
                  focusBorderColor="#FFD700"
                  borderColor={'black'} 
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </FormControl>
              <FormControl id="password">
                <FormLabel>Mot de passe</FormLabel>
                <InputGroup size='md'>
                  <Input
                    isRequired={true}
                    mb='24px'
                    size='lg'
                    type={show ? "text" : "password"}
                    color={'black'} 
                    bg={'white'} 
                    focusBorderColor="#FFD700"
                    borderColor={'black'}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <InputRightElement display='flex' alignItems='center' mt='4px'>
                    <Icon
                      color={'#FFD700'}
                      _hover={{ cursor: "pointer" }}
                      as={show ? RiEyeCloseLine : MdOutlineRemoveRedEye}
                      onClick={handleClick}
                    />
                  </InputRightElement>
                </InputGroup>
              </FormControl>
              <Button 
                colorScheme={'yellow'} 
                variant={'solid'} 
                mt={4}
                isDisabled={isButtonDisabled}
                onClick={handleSubmit}
              >
                Se connecter
              </Button>
            </Stack>
          </Flex>
        </Stack>
      <Footer />
    </>
  )
}